export var Flags;
(function (Flags) {
    Flags["POK_42_QR_CODE"] = "pok_42_qr_code";
    Flags["POK_45_SSO_GITHUB"] = "pok_45_sso_github";
    Flags["POK_46_SSO_GITLAB"] = "pok_46_sso_gitlab";
    Flags["POK_48_ADD_A_REPLAY_FUNCTIONALITY"] = "pok_48_add_a_replay_functionality";
    Flags["POK_54_KEEP_TRACK_OF_PLAYED_ROUNDS"] = "pok_54_keep_track_of_played_rounds";
})(Flags || (Flags = {}));
//# sourceMappingURL=flags.js.map